module.exports = __webpack_public_path__ + "static/media/bulk-quote-logout.648c6a13.png";